import React from "react";
import { useEventsAll } from "../util/db";
import AdminPageEventsRow from "./AdminPageEventsRow";
import { Card, Table } from "react-bootstrap";
import FormAlert from "./FormAlert";

function AdminPageEvents({ auth }) {
  //look up all events in db
  const {
    data: items,
    status: itemsStatus,
    error: itemsError,
  } = useEventsAll();

  return (
    <>
      {itemsError && (
        <div className="mb-3">
          <FormAlert type="error" message={itemsError.message} />
        </div>
      )}

      {itemsStatus !== "loading" && items && items.length > 0 && (
        <Card
          className="mb-3"
          style={{
            borderRadius: "10px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <Card.Header
            style={{
              background: "#2D083F",
              color: "white",
              borderRadius: "10px 10px 0 0",
            }}
          >
            <Card.Title className="mb-0" style={{ color: "white" }}>
              Events
            </Card.Title>
          </Card.Header>
          <Card.Body style={{ background: "#FFFFFF", padding: "0" }}>
            <Table responsive className="table mb-0">
              <thead>
                <tr>
                  <th>Event Name</th>
                  <th>LD</th>
                  <th>Manage</th>
                  <th>Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <AdminPageEventsRow key={index} item={item} />
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      )}

      {itemsStatus !== "loading" && items && items.length === 0 && (
        <Card
          className="mb-3"
          style={{
            borderRadius: "10px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <Card.Header
            style={{
              background: "#2D083F",
              color: "white",
              borderRadius: "10px 10px 0 0",
            }}
          >
            <Card.Title className="mb-0" style={{ color: "white" }}>
              Events
            </Card.Title>
          </Card.Header>
          <Card.Body
            style={{ background: "#FFFFFF", borderRadius: "0 0 10px 10px" }}
          >
            <div className="text-center py-4">No events found.</div>
          </Card.Body>
        </Card>
      )}
    </>
  );
}

export default AdminPageEvents;
